// extracted by mini-css-extract-plugin
export var blockedMessage = "_bj-3";
export var blockedOverlay = "_bj-1";
export var fadeIn = "_bj-2";
export var hereLink = "_bj-0";
export var slideUp = "_bj-4";